var r = /* @__PURE__ */ ((o) => (o.Simple = "SIMPLE", o.Normal = "NORMAL", o.SelectionPage = "SELECTION", o))(r || {});
export {
  r as BannerStyle
};
//# sourceMappingURL=index2.js.map
